import { render, staticRenderFns } from "./RadioCards.vue?vue&type=template&id=252cbd36&scoped=true"
import script from "./RadioCards.vue?vue&type=script&lang=js"
export * from "./RadioCards.vue?vue&type=script&lang=js"
import style0 from "./RadioCards.vue?vue&type=style&index=0&id=252cbd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cbd36",
  null
  
)

export default component.exports